module.exports = __webpack_public_path__ + "img/cap_sac.45387dd1.svg";